import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import { uploadZips } from "@/core/app/slices/clinical/clinical.service"
import { RootState } from "@/core/app/store"
import { caseManagement } from "@/gluelayer"

type useSTLuploadProps = {
  newUdesignJson: {
    upperUploaded: boolean
    lowerUploaded: boolean
    UpperType: "A" | "R" | "" | "--"
    LowerType: "A" | "R" | "" | "--"
  }
  uassist_round: number
  patientId: string
  caseId: string
  callback?: () => void
}

function useSTLupload() {
  const dispatch = useAppDispatch()

  const {
    user: { app_permissions, current_orgId },
  } = useAppSelector((state: RootState) => state.userService)
  const { clinicalSettings } = useAppSelector(
    (state: RootState) => state.userService,
  )
  const { caseDetail } = useAppSelector((state: RootState) => state.caseService)
  const { caseDetailForShape, scannerSelect } = useAppSelector(
    (state: RootState) => state.patientService,
  )

  async function handleStlUpload({
    newUdesignJson,
    uassist_round,
    patientId,
    caseId,
    callback,
  }: useSTLuploadProps) {
    caseManagement
      .saveJsonDataToZip(
        JSON.stringify(clinicalSettings),
        "uassist_team_settings.json",
        "Setting Data2",
      )
      .then(() => {
        //const zip = uassist_round > 0 ? ["bulk10"] : [...FILEZIPS]// when click Next button in CreateRefinement,only upload bulk10.zip
        const zip = ["bulk10"]
        caseManagement.getCaseFiles(zip).then(async (r) => {
          console.log(
            "🚀 ~ caseManagement.getCaseFiles ~ rrrrrrrrrrrrrrrrrr:",
            r,
          )
          const zips = []
          if (r) {
            for (const k in r) {
              zips.push({
                fileName: k,
                file: r[k],
              })
            }
            await uploadZips({
              zips,
              patientId,
              caseId,
              orgId: current_orgId,
              callback,
            })
            callback && callback()
          }
        })
      })
  }

  return {
    handleStlUpload,
  }
}

export default useSTLupload
